/**
 * The words an office user reads on every old / new UI switch (new-UI release plan, 2026-10-10), in ONE
 * place so the page link, the account menu, the phone drawer, the classic gear menu and the welcome
 * banner never drift apart. Pure — no store, no storage, no clock.
 *
 * ⛔ KEEP THIS FILE IMPORT-FREE like the rest of src/utils/followups/ (followups-state.test.js
 * executes every file there verbatim); callers pass uiVersion.js CLASSIC_UNTIL in.
 */

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/**
 * A 'YYYY-MM-DD' date (uiVersion.js CLASSIC_UNTIL, '2026-11-09') as the short date users read, "Nov 9". Built from the parts —
 * no Date, no timezone parsing, so the day can never slide by one in a western timezone. A value that
 * is not 'YYYY-MM-DD' comes back unchanged (a typo must show something, not "NaN").
 */
export function formatClassicUntil(iso) {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(iso));
  if (!m) return String(iso);
  const month = Number(m[2]);
  const day = Number(m[3]);
  if (month < 1 || month > 12 || day < 1 || day > 31) return String(iso);
  return `${MONTHS[month - 1]} ${day}`;
}

/** The menu / button label for an office switch whose click goes TO `target` ('old' or 'new'). */
export function officeSwitchLabel(target) {
  return target === 'old' ? 'Switch to classic Teamio' : 'Try the new Teamio';
}

/**
 * The question an office user is asked before an old / new switch RELOADS the page (a reload loses
 * anything half-typed). `target` 'old' ⇒ going to classic; anything else ⇒ going to the new Teamio.
 */
export function officeSwitchConfirmText(target) {
  const where = target === 'old' ? 'classic' : 'the new';
  return `Switch to ${where} Teamio?\n\nThe page will reload. Save anything you are typing first.`;
}
